
import { Component, Vue } from 'vue-property-decorator'
import MenDianComp from '@/views/industryMall/orderManage/components/mendian.vue'
import WeiDianComp from '@/views/industryMall/orderManage/components/weidian.vue'
import { Getter } from "vuex-class";

@Component({
  name: 'storeOrderManage',
  components: { MenDianComp, WeiDianComp }
})
class storeOrderManage extends Vue {
  @Getter companyId!: string
  $refs: {
  }
  active = 0

  changeTabs  (e: any) {
  this.active = e
}

  created () {
    const { active = 0 } = this.$route.query
    this.active = Number(active)
  }
}
export default storeOrderManage
